// extracted by mini-css-extract-plugin
export default {"button":"Button_button__oOVl9","disabled":"Button_disabled__zo8Ir","shake":"Button_shake__Skdv5","color":"Button_color__71Ip4"};